import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGaurd } from '../app/gaurd/admin-gaurd.service'


const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(mod => mod.AuthModule),
    data: { preload: true }
  },
  {
    path: 'analytics',
    loadChildren: () => import('./features/analytics/analytics.module').then(mod => mod.AnalyticsModule),
    data: { preload: true },
    canLoad: [AdminGaurd]
  },
  {
    path: 'crew-data',
    loadChildren: () => import('./features/crews/crews.module').then(mod => mod.CrewsModule),
    data: { preload: true },
    canLoad: [AdminGaurd]
  },
  {
    path: 'vessels',
    loadChildren: () => import('./features/vessels/vessels.module').then(mod => mod.VesselsModule),
    data: { preload: true },
    canLoad: [AdminGaurd]
  },
  {
    path: 'about',
    loadChildren: () => import('./features/about/about.module').then(mod => mod.AboutModule),
    data: { preload: true },
    canLoad: [AdminGaurd]
  },
  {
    path: 'settings',
    loadChildren: () => import('./features/settings/settings.module').then(mod => mod.SettingsModule),
    data: { preload: true },
    canLoad: [AdminGaurd]
  },
  {
    path: 'nominations',
    loadChildren: () => import('./features/nominations/nominations.module').then(mod => mod.NominationsModule),
    data: { preload: true },
    canLoad: [AdminGaurd]
  },
  {
    path: 'shortlisted',
    loadChildren: () => import('./features/shortlist/shortlist.module').then(mod => mod.ShortListModule),
    data: { preload: true },
    canLoad: [AdminGaurd]
  },
  {
    path: 'safetychampions',
    loadChildren: () => import('./features/safetychampion/safetychampion.module').then(mod => mod.SafetyChampionModule),
    data: { preload: true },
    canLoad: [AdminGaurd]
  },

  {
    path: 'voting',
    loadChildren: () => import('./features/voting/voting.module').then(mod => mod.VotingListModule),
    data: { preload: true }
  },

  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/auth/login'
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
